import { createContext, useContext, useReducer } from 'react';
import { ACTION_TYPES, ClientsManagementReducer, ClientsManagementState } from './clients-management-reducer';
import { IListClientsResponse } from '../../../../model/base/response/list-clients-response';
import { PaginationResponse } from '../../../../model/base/response/pagination-response';
import { IListClientsRequest } from '../../../../model/base/request/list-clients-request';
import { ICreateClientRequest } from '../../../../model/base/request/create-client-request';

const ClientsManagementContext = createContext<ClientsManagementState | undefined>(undefined);
const ClientsManagementContextDispatchContext = createContext({} as any);

const ClientsManagementProvider = ({ children }: { children: React.ReactNode }) => {
    const [state, dispatch] = useReducer(ClientsManagementReducer, {
        clientsPagedResponse: {
            items: [] as IListClientsResponse[],
            page: 0,
            pageSize: 1,
            pageCount: 0
        } as PaginationResponse<IListClientsResponse>,
        clientsPagedRequest: {
            page: 0,
            pageSize: 50,
            name: "",
            document: "",
            entityType: undefined,
        } as IListClientsRequest,
        selectedClient: null,
        isLoadingData: false,
        isLoadingClient: false,
        isDrawerOpen: false,
        isEditing: false,
        clientForm: {
            entityType: 0,
            address: {
                cityId: 0
            }
        } as ICreateClientRequest,
        listStateResponse: [],
        listCityResponse: [],
        brandLogo: null,
    } as ClientsManagementState);

    return (
        <ClientsManagementContext.Provider value={state}>
            <ClientsManagementContextDispatchContext.Provider value={dispatch}>
                {children}
            </ClientsManagementContextDispatchContext.Provider>
        </ClientsManagementContext.Provider>
    );
}

const useClientsManagementState = () => {
    const context = useContext(ClientsManagementContext);
    if (context === undefined) {
        throw new Error('useClientsManagementState must be used within a ClientsManagementProvider');
    }
    return context;
}

const useClientsManagementDispatch = () => {
    const context = useContext(ClientsManagementContextDispatchContext);
    if (context === undefined) {
        throw new Error('useClientsManagementDispatch must be used within a ClientsManagementProvider');
    }
    return context;
}

export { ClientsManagementProvider, useClientsManagementDispatch, useClientsManagementState, ACTION_TYPES };